import { version } from "./version";

const {
  formField: { releaseNotes, configFile },
} = version;

export const connectorVersionInitialValues = {
  [releaseNotes.name]: "",
  [configFile.name]: "",
};
